<template>
  <div class="relative border-b border-l border-neutral-border-default">
    <ReviewItemDetails
      :expansion-panel="expansionPanel"
      :is-metadata-expanded="isMetadataExpanded"
      :review-item="reviewItem"
    />
  </div>
  <div class="border-b border-l border-mid-neutral-50">
    <AttributeEditor
      v-if="isIncluded"
      v-model="extractionAnswer"
      :attribute-structure="attribute"
      :study="reviewItem"
      :is-expanded="expansionPanel.isShown.value"
      :is-review-read-only="review.isLocked.value"
      :expansion-panel="expansionPanel"
      :show-equivalent-copy="showCopyIndicator"
    />
  </div>
</template>

<script setup lang="ts">
import { injectStrict } from "@app/utils/injectStrict";
import { ReviewItem } from "@core/domain/models/reviewItem.model";
import { computed, ref } from "vue";
import { INCLUDED } from "@core/domain/types/included-screening-criterion.type";
import { ReviewKey } from "@app/views/Review/use-review";
import useExpansionPanel from "@app/composables/use-expansion-panel";
import AttributeEditor from "./AttributeEditor.vue";
import ReviewItemDetails from "@app/views/Review/Execute/ReviewItemDetails/ReviewItemDetails.vue";
import { AttributeStructure } from "@core/domain/models/data-extraction-plan-attribute";
import { DevToolboxKey } from "@app/injectionKeys";

const props = defineProps<{
  reviewItem: ReviewItem;
  isMetadataExpanded: boolean;
  attribute: AttributeStructure;
}>();

const review = injectStrict(ReviewKey);
const { isCuttingEdge } = injectStrict(DevToolboxKey);

const expansionPanel = useExpansionPanel();
const extractionAnswer = ref<string>();

const isIncluded = computed(() => {
  return props.reviewItem.fullTextScreening === INCLUDED;
});

const currentAttribute = computed(() =>
  props.reviewItem.synthesis?.attributes?.find(
    (attr) => attr.attributeStructureId === props.attribute?.id,
  ),
);

const isFinalized = computed(() => currentAttribute.value?.isFinalized ?? false);

const showCopyIndicator = computed(
  () => isCuttingEdge && isIncluded.value && !isFinalized.value && !review.isReviewReadonly.value,
);
</script>
